import React from "react";
import "./proposalForm.css";

export const ProposalConfirmList = ({
  Title,
  Description,
  line = true,
  ...rest
}) => {
  return (
    <div className="confirm-card mb-3" {...rest}>
      <div className="card-body">
        <h6 className="card-title vicus-blue mb-2">{Title}</h6>
        <p className="card-text mb-0">{Description}</p>
      </div>
    </div>
  );
};
